// Get all list items
const menuItems = document.querySelectorAll('.custom-megamenu');

menuItems.forEach(item => {
  const targetId = item.getAttribute('data-megamenu');
  const targetDiv = document.getElementById('parent-' + targetId);
  
  // Add hover events for the menu item
  item.addEventListener('mouseenter', () => {
    if (targetDiv) {
      targetDiv.classList.remove('hide');
    }
  });

  item.addEventListener('mouseleave', (e) => {
    if (targetDiv) {
      // Check if the mouse has moved to the megamenu
      if (!targetDiv.contains(e.relatedTarget)) {
        targetDiv.classList.add('hide');
      }
    }
  });

  // Add hover events for the megamenu
  if (targetDiv) {
    targetDiv.addEventListener('mouseenter', () => {
      targetDiv.classList.remove('hide');
    });

    targetDiv.addEventListener('mouseleave', (e) => {
      // Check if the mouse has moved back to the menu item
      if (!item.contains(e.relatedTarget)) {
        targetDiv.classList.add('hide');
      }
    });
  }
});
